import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const StatusColorBox = ({ backgroundColor, outlineColor, children }) => (
    <Box
        className='color-box'
        sx={{
            backgroundColor,
            width: '16px',
            height: '16px',
            borderRadius: '4px',
            outline: '2px solid',
            outlineOffset: '-2px',
            outlineColor,
        }}
    >
        {children}
    </Box>
);

StatusColorBox.propTypes = {
    backgroundColor: PropTypes.string.isRequired,
    outlineColor: PropTypes.string.isRequired,
    children: PropTypes.node,
};

export default StatusColorBox;
